
import InfoIcon from "@mui/icons-material/Info";
import clsx from 'clsx';
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import MuiAlert from '@mui/material/Alert';



const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

export default class Toaster extends React.Component{


    constructor(props) {
        super(props)
        this.state = {
            toast: {
                open: false,
                variant: "success",
                message: "hallo"
            }
        }
    }

    onMessage(event) {
        if(event.data && event.data.type === "toast") {
            this.setState({toast: event.data})

        }
    }

    componentDidMount() {
        window.addEventListener('message', this.onMessage.bind(this));

    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onMessage.bind(this));
    }



    render() {
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={this.state.toast.open}
                autoHideDuration={6000}
                onClose={() => {this.setState({toast: {open: false, variant: this.state.toast.variant, message: ""}})}}
            >
                <Alert 
                    severity={this.state.toast.variant} 
                    sx={{ width: '100%' }} 
                    onClose={() => {this.setState({toast: {open: false, variant: this.state.toast.variant, message: ""}})}} >
                        {this.state.toast.message}
                </Alert>
            </Snackbar>
        )
    }
}

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const useStyles1 = {
    success: {
        backgroundColor: "green",
    },
    error: {
        backgroundColor: {

            main: 'rgba(127, 45, 67, 0.92)',
            dark: 'rgba(127, 45, 67, 1)',
            contrastText: 'rgba(127, 45, 67, 0.7)',

        },
    },
    info: {
        backgroundColor: "blue",
    },
    warning: {
        backgroundColor: "orange",
    },
    icon: {
        fontSize: 20,
        marginRight: 5,
        opacity: 0.9,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: 5,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
};

function MySnackbarContentWrapper(props) {
    const classes = useStyles1;
    const { className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];
    var backgroundColor = "#479F4B";
    if(variant === "error") {
        backgroundColor = "#D03134"
    }
    if(variant === "success") {
        backgroundColor = "#479F4B"
    }
    if(variant === "warning") {
        backgroundColor = "#FD9F28"
    }

    if(variant === "info") {
        backgroundColor = "#2178CF"
    }

    return (
        <SnackbarContent
            style={{backgroundColor: backgroundColor, zIndex: 20000}}
            aria-describedby="client-snackbar"
             message={
                <span id="client-snackbar" style={{...useStyles1.message, display: "flex", alignItems: "center"}}>
                    <Icon style={useStyles1.icon} /> 
                    <CheckCircleIcon/>
                    {message}
                </span>
            }
             action={[
                <IconButton key="close" aria-label="Close" color="inherit" onClick={onClose}>
                    <CloseIcon style={useStyles1.icon} />
                </IconButton>,
            ]} 
             {...other}  
        />
    );
}